import groupBy from 'lodash-es/groupBy';

import {
  AssistanceSearchInclusion, AssistanceSearchInclusionDetail, AssistanceSearchResult, AssistanceServicesDetail
} from '@shared/travel-assistance/entities/booking-assistance';
import { AssistanceCategories } from '@ux/components/chubb-banners/constants/assistance-categories';

export function assistanceHighlightedBanner(result: AssistanceSearchResult): AssistanceSearchInclusion[] {
  const plan = result?.Plans?.[0];
  if (plan) {
    const inclusions = plan.Inclusions;
    const highlighted = inclusions?.filter(inclusion =>
      inclusion.Category?.toUpperCase() === AssistanceCategories.Highlighted);
    if (highlighted?.length) return highlighted;
    else return inclusions ? inclusions.slice(0, 4) : [];
  } else return [];
}

export function assistanceValuesDetail(result: AssistanceSearchResult): AssistanceSearchInclusionDetail[] {
  const plan = result?.Plans?.[0];
  if (plan) {
    const inclusions = plan.Inclusions;
    if (inclusions) {
      const categories: AssistanceSearchInclusionDetail[] = [];
      const filterHighlighted = inclusions.filter(inclusion =>
        inclusion.Category?.toUpperCase() !== AssistanceCategories.Highlighted);
      const groupByCategory = groupBy(filterHighlighted, 'Category');
      for (const category in groupByCategory) {
        if (Object.prototype.hasOwnProperty.call(groupByCategory, category)) {
          const values: AssistanceSearchInclusion[] = groupByCategory[category];
          categories.push({ Inclusions: values, Category: category });
        }
      }
      return categories;
    } else return [];
  } else return [];
}

export function assistanceValuesDetailByUserHistory(services: AssistanceServicesDetail): AssistanceSearchInclusionDetail[] {
  if (services) {
    const inclusions = services.Inclusions;
    if (inclusions) {
      const categories: AssistanceSearchInclusionDetail[] = [];
      const filterHighlighted = inclusions.filter(inclusion =>
        inclusion.Category?.toUpperCase() !== AssistanceCategories.Highlighted);
      const groupByCategory = groupBy(filterHighlighted, 'Category');
      for (const category in groupByCategory) {
        if (Object.prototype.hasOwnProperty.call(groupByCategory, category)) {
          let key = category;
          const values: AssistanceSearchInclusion[] = groupByCategory[category];
          if (category === 'undefined') key = '';
          categories.push({ Inclusions: values, Category: key });
        }
      }
      return categories;
    } else return [];
  } else return [];
}
